import {useState} from "react";
import AddToWaitlistModal, {useIsWaitlistEnabled} from "~/components/waitlist/AddToWaitlistModal";

const AddToWaitlistCTA = ({eventType, bookableResource, settings, className}) => {
    const [showModal, setShowModal] = useState(false)
    const isWaitlistEnabled = useIsWaitlistEnabled(settings);

    if (!isWaitlistEnabled) {
        return null;
    }

    return (
        <div className={`text-center text-sm ${className}`}>
            <div>
                Don’t see an available date/time? <a href="#" onClick={(ev) => {
                    ev.preventDefault();
                    setShowModal(true);
            }}>Join Waitlist</a>
            </div>
            <AddToWaitlistModal
                eventType={eventType}
                bookableResource={bookableResource}
                isOpen={showModal}
                onClose={() => setShowModal(false)}
            />
        </div>
    )
}

export default AddToWaitlistCTA;
